export const ProductType = Object.freeze({
  BEGINNER: 'BEGINNER',
  BEGINNER_TRIAL: 'BEGINNER_TRIAL',
  ADVANCED: 'ADVANCED',
  ADVANCED_TRIAL: 'ADVANCED_TRIAL',
})
